module.exports = __webpack_public_path__ + "img/COMO_01H.2f68ec2d.jpg";